import LogoImage from '../LogoImage/LogoImage';
import styles from './Footer.module.css'
import { Link } from 'react-router-dom';
import { useWindowSize } from "@uidotdev/usehooks";
import { useEffect, useState } from 'react';

function Footer() {
  const windowSize = useWindowSize();
  const [showContact, setShowContact] = useState(true);
  const [showLinks, setShowLinks] = useState(true);

  useEffect(() => {
    if (windowSize.width) {
      if (windowSize.width < 1000) {
        setShowContact(false);
      }
      else {
        setShowContact(true);
      }

      if (windowSize.width < 800) {
        setShowLinks(false);
      }
      else {
        setShowLinks(true);
      }
    }
  }, [windowSize]);

  return (
    <div className={styles.Footer}>
      <div className={styles.FooterLeft}>
        <LogoImage />
        <div className={styles.CodeAblaze}>
          <div>CodeAblaze - Blazing the Path for</div>
          <div>Equal Opportunity and Rising Coders</div>
        </div>
        <div className={styles.Copyright}>
          Copyright © CodeAblaze - All rights reserved
        </div>
      </div>
      {
        showContact &&
        <div className={styles.Contact}>
          <div className={styles.ContactHeader}>Contact:</div>
          <div>
            For General Questions:
          </div>
          <div className={styles.GeneralEmail}>
            <a href="mailto:codeablazeprogram@gmail.com">codeablazeprogram@gmail.com</a>
          </div>
          <div>
            Email our staff with specific questions
            <span> </span>
            <Link to="/contact">here</Link>
          </div>
        </div>
      }
      {
        showLinks &&
        <div className={styles.QuickLinks}>
          <div className={styles.QuickLinkHeader}>Quick Links</div>
          <div className={styles.LinkItem}><Link to="/">Home Page</Link></div>
          <div className={styles.LinkItem}><Link to="/program">Our Program</Link></div>
          <div className={styles.LinkItem}><Link to="/about">About Us</Link></div>
          <div className={styles.LinkItem}><Link to="/contact">Contact Us</Link></div>
          <div className={styles.LinkItem}><Link to="/join">Join or Volunteer</Link></div>
        </div>
      }
    </div>
  );
}

export default Footer;
